module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAFYwwxmAAAABGdBTUEAALGPC/xhBQAAALZJREFUOBG1k00KwjAQhVs8klfogQRd6aYVvJH7VkGP5EIo+r5FSpNOambhwIPMey8z+a0qf3TFU3ap85AS5G+LhPvkBMq0ObGWcBFoPgjkVkTVo8Ryz7nzPMmNiyr+NLF4TFdhk2slfkDbCycGJcEZrm4ktHvKuBUa4SYsIhhTgQ4PYRTuqejJKcQhdJ5JlpcD4rUdLdHDcS28MQq9hF6AA95gZ8yfImx39XYmt2Pwt8J8NfdqvyBJIQu3+IwdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/_atomic/ArrowButton/assets/left-arrow.png
// module id = 1282
// module chunks = 0